export enum EDataValidationContext {
    ESaveSubmit,
    EActionItem,
}